// Portuguese (Português)
export default {
  nav: {
    home: 'Início',
    wall: 'O Mural',
    groups: 'Grupos',
    users: 'Usuários',
    profile: 'Meu Perfil',
    help: 'Ajuda',
    membership: 'Adesão',
    logout: 'Sair',
    login: 'Entrar'
  },
  auth: {
    loginSubtitle: 'Entre para continuar',
    email: 'E-mail',
    password: 'Senha',
    noAccount: 'Não tem uma conta?',
    createAccount: 'Criar conta',
    loginFailed: 'Falha no login. Verifique seu e-mail e senha.',
    alreadyHaveAccount: 'Já tem uma conta?',
    register: 'Registrar',
    name: 'Nome',
    confirmPassword: 'Confirmar senha',
    registrationSuccess: 'Conta criada! Você já pode entrar.',
    registrationFailed: 'Não foi possível criar a conta.'
  },
  home: {
    title: 'Comunidade',
    tagline: 'Um lugar tranquilo na internet – sem anúncios.',
    description: 'Compartilhe o dia a dia com família, amigos e novos conhecidos. Sem ruído, sem rastreamento, sem venda de dados.',
    features: {
      noAds: 'Sem anúncios',
      simple: 'Simples e claro',
      safe: 'Ambiente seguro + moderação'
    },
    cta: {
      openWall: 'Abrir o Mural',
      createProfile: 'Criar perfil grátis',
      goToWall: 'Ir para o Mural',
      readMore: 'Leia sobre a ideia'
    },
    pricing: 'O site é gratuito.',
    pricingDetail: 'Mas nós também precisamos viver – por favor, considere doar.'
  },
  wall: {
    title: 'O Mural',
    subtitle: 'Aqui você vê publicações da comunidade.',
    writePost: 'ESCREVER NO MURAL',
    placeholder: 'Escreva sua publicação aqui...',
    group: 'Grupo',
    noGroup: 'Nenhum grupo',
    selectImage: 'Selecionar imagem',
    noFileSelected: 'Nenhum arquivo selecionado.',
    send: 'Publicar',
    public: 'Público',
    members: 'Membros',
    private: 'Privado',
    visibility: 'Visibilidade'
  },
  groups: {
    title: 'Grupos',
    subtitle: 'Grupos que fazem sentido – local, hobbies, viagens, caminhadas – fácil de acompanhar.',
    createGroup: 'Criar grupo',
    allGroups: 'Todos os grupos',
    myGroups: 'Meus grupos',
    searchPlaceholder: 'Pesquisar grupos...',
    noGroups: 'Nenhum grupo encontrado',
    noMyGroups: 'Você ainda não é membro de nenhum grupo',
    groupName: 'Nome do grupo',
    description: 'Descrição',
    publicGroup: 'Grupo público (todos podem ver e participar)',
    private: 'Privado',
    createdBy: 'Criado por',
    members: 'membros',
    postsCount: 'publicações',
    noDescription: 'Sem descrição',
    join: 'Participar',
    leave: 'Sair',
    open: 'Abrir',
    leaveConfirm: 'Tem certeza de que deseja sair deste grupo?',
    postsTab: 'Publicações',
    membersTab: 'Membros',
    noPosts: 'Ainda não há publicações neste grupo',
    joinToSee: 'Participe do grupo para ver as publicações',
    about: 'Sobre',
    createdOn: 'Criado em',
    editGroup: 'Editar grupo',
    deleteConfirm: 'Tem certeza de que deseja excluir este grupo? Todas as publicações serão excluídas.',
    setMember: 'Definir como membro',
    setModerator: 'Definir como moderador',
    setAdmin: 'Definir como admin',
    removeMember: 'Remover do grupo',
    removeMemberConfirm: 'Tem certeza de que deseja remover {name} do grupo?',
    changeCover: 'Alterar imagem de capa',
    invalidImageType: 'Tipo de arquivo inválido. Selecione uma imagem.',
    imageTooLarge: 'A imagem é muito grande. Máximo 5MB.'
  },
  profile: {
    title: 'Meu Perfil',
    editProfile: 'Editar perfil',
    myPosts: 'Minhas publicações',
    myGroups: 'Meus grupos',
    overview: 'Visão geral',
    edit: 'Editar',
    settings: 'Configurações',
    activity: 'Atividade',
    bio: 'Sobre mim',
    location: 'Localização',
    website: 'Site',
    birthday: 'Aniversário',
    interests: 'Interesses',
    joined: 'Entrou em',
    posts: 'Publicações',
    comments: 'Comentários',
    reactions: 'Reações',
    privacy: 'Privacidade',
    showRealName: 'Mostrar nome real publicamente',
    showEmail: 'Mostrar e-mail publicamente',
    emailNotifications: 'Notificações por e-mail',
    changePassword: 'Alterar senha',
    currentPassword: 'Senha atual',
    newPassword: 'Nova senha',
    confirmPassword: 'Confirmar senha',
    uploadAvatar: 'Enviar foto de perfil',
    changeAvatar: 'Alterar foto de perfil',
    removeAvatar: 'Remover foto de perfil',
    bioPlaceholder: 'Conte-nos sobre você...',
    interestsPlaceholder: 'No que você está interessado?',
    saveChanges: 'Salvar alterações',
    cancelChanges: 'Cancelar',
    profileUpdated: 'Perfil atualizado!',
    passwordChanged: 'Senha alterada!',
    avatarUploaded: 'Foto de perfil enviada!',
    recentPosts: 'Publicações recentes',
    recentComments: 'Comentários recentes',
    recentReactions: 'Reações recentes',
    noPosts: 'Ainda não há publicações',
    noComments: 'Ainda não há comentários',
    noReactions: 'Ainda não há reações',
    downloadData: 'Baixar meus dados',
    deleteAccount: 'Excluir conta',
    deleteAccountWarning: 'Isso excluirá permanentemente sua conta e todos os dados. Esta ação não pode ser desfeita.',
    age: 'anos'
  },
  common: {
    loading: 'Carregando...',
    error: 'Ocorreu um erro',
    success: 'Sucesso!',
    cancel: 'Cancelar',
    save: 'Salvar',
    delete: 'Excluir',
    edit: 'Editar',
    post: 'Publicar',
    comment: 'Comentário',
    quote: 'Citar',
    reply: 'Responder',
    confirm: 'Confirmar',
    ok: 'OK',
    data: 'Dados',
    noComments: 'Ainda não há comentários. Seja o primeiro!',
    writeComment: 'Escreva um comentário...',
    replyToComment: 'Responder ao comentário...',
    deleteConfirm: 'Excluir esta publicação?',
    contentRequired: 'O conteúdo não pode estar vazio',
    updateFailed: 'Falha ao atualizar a publicação',
    deleteFailed: 'Falha ao excluir a publicação',
    commentFailed: 'Falha ao enviar o comentário'
  },
  users: {
    searchTitle: 'Encontrar usuários',
    searchSubtitle: 'Pesquisar usuários na comunidade',
    searchPlaceholder: 'Pesquisar por nome de usuário, nome ou e-mail...',
    search: 'Pesquisar',
    searchHint: 'Digite pelo menos 2 caracteres para pesquisar usuários',
    resultsFound: '{count} usuário(s) encontrado(s)',
    noResults: 'Nenhum usuário encontrado. Tente outro termo de pesquisa.'
  },
  validation: {
    required: 'Este campo é obrigatório',
    email: 'Digite um e-mail válido',
    maxLength: 'Máximo de {max} caracteres',
    passwordMatch: 'As senhas devem ser iguais'
  }
}
